<template>
    <Modal>
        <ModalCard
            @cancel="cancel"
            :activeValidate="etatEquipement !== undefined"
            :headerTitle="$t('equipement.condition.title')"
            @confirm="confirm"
        >
            <span class="title">
                {{ $t('equipement.condition.subtitle') }}
                <ReglePastille cle="demandeIntervention.etatEquipementDefaut" />
            </span>
            <div class="buttons-container">
                <div
                    v-for="etat in etatsEquipement"
                    v-on:click="pick(etat)"
                    class="button-container"
                    :class="getClass(etat)"
                    :key="etat.id"
                >
                    <span class="button-title">
                        {{ etat.libelle }}
                    </span>
                </div>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { EtatEquipement } from '@/models/EtatEquipement';
import { INTERVENTION } from '@/modules/Intervention/store/mutation-types';
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { Modal, ModalCard, ReglePastille },
    props: {
        active: {
            type: Boolean,
            required: true,
        },
    },
    beforeMount() {
        this.$store.commit(INTERVENTION.SET_ETAT_EQUIPEMENT, this.etatsEquipement.find((etat: EtatEquipement) => {return etat.id == '1';}));
    },
    methods: {
        pick(condition: EtatEquipement) {
            if (condition === this.etatEquipement) {
                this.$store.commit(INTERVENTION.SET_ETAT_EQUIPEMENT, undefined);
            } else {
                this.$store.commit(INTERVENTION.SET_ETAT_EQUIPEMENT, condition);
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm');
        },
        getClass(etat: EtatEquipement) {
            const selected = this.etatEquipement?.id === etat.id;
            switch (etat.criticite) {
                case '1':
                    return `normal${selected ? ' normal-selected selected' : ''}`;
                case '2':
                    return `degrade${selected ? ' degrade-selected selected' : ''}`;
                case '3':
                    return `arret${selected ? ' arret-selected selected' : ''}`;
                default:
                    return 'normal';
            }
        },
    },
    computed: {
        etatEquipement(): EtatEquipement | undefined {
            return this.$store.getters.getInterventionEquipementConditionValue;
        },
        etatsEquipement(): EtatEquipement[] {
            return this.$store.getters['equipementModule/getEtats'];
        },
    },
});
</script>

<style scoped>
.buttons-container {
    margin-top: 16px;
    display: flex;
    gap: 16px;
}
.title {
    margin: 0;
}
.button-container {
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    padding: 10px 16px;
    cursor: pointer;
}
.button-title {
    font-size: var(--font-size-small);
    font-weight: var(--font-weight-bold);
}
.normal {
    color: var(--color-principal);
    border-color: var(--color-principal);
}
.normal-selected {
    background-color: var(--color-principal);
}
.degrade {
    color: var(--color-warning);
    border-color: var(--color-warning);
}
.degrade-selected {
    background-color: var(--color-warning);
}
.arret {
    color: var(--color-danger);
    border-color: var(--color-danger);
}
.arret-selected {
    background-color: var(--color-danger);
}
.selected {
    color: var(--white);
}
</style>
